import { Button } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { DesktopLoanSummary } from './DesktopLoanSummary/DesktopLoanSummary';
import { MobileLoanSummary } from './MobileLoanSummary/MobileLoanSummary';
import { useMediaQuery } from '../../../../../customHooks/useMediaQuery';

const ContinueButton = () => (
    <Button
        className="w-full rounded-full text-primary-10"
        variant="secondary-alt"
    >
        <FormattedMessage
            id="_.loan_summary.continue_button"
            defaultMessage="Continue to final checks"
        />
    </Button>
);

export const LoanSummary = () => {
    const isDesktop = useMediaQuery('(min-width: 768px)');

    // TODO k.anyabuike: Get repayment summary data here and pass it to the components

    return isDesktop ? (
        <DesktopLoanSummary continueButton={<ContinueButton />} />
    ) : (
        <MobileLoanSummary continueButton={<ContinueButton />} />
    );
};
